export var ViewMode;
(function (ViewMode) {
    ViewMode[ViewMode["ONSITE"] = 0] = "ONSITE";
    ViewMode[ViewMode["FACE_TO_WORLD"] = 1] = "FACE_TO_WORLD";
    ViewMode[ViewMode["FACE_TO_FACE"] = 2] = "FACE_TO_FACE";
    ViewMode[ViewMode["UNKNOWN"] = 3] = "UNKNOWN";
})(ViewMode || (ViewMode = {}));
//# sourceMappingURL=use_view_mode.js.map